<script setup lang="ts">
import { useSubscription } from '@/composables/useSubscription'
import { computed, onMounted } from 'vue'

const { planName, usedDays, badgeColor, tooltipText, subscription, subscriptionLoading, subscriptionLoaded, refreshFromApi } = useSubscription()
const showUsageCounter = computed(() =>
  Boolean(
    subscription.value.status
    && planName.value
    && usedDays.value.total > 0
    && subscription.value.status !== 'pending_payment',
  ),
)

const showLoader = computed(() =>
  subscriptionLoading.value && !subscriptionLoaded.value && !subscription.value.status,
)

onMounted(() => {
  refreshFromApi()
})
</script>

<template>
  <span class="d-inline-flex align-center me-2">
    <template v-if="showLoader">
      <VProgressCircular indeterminate size="24" width="2" color="primary" />
    </template>
    <VTooltip v-else :text="tooltipText" location="bottom">
      <template #activator="{ props }">
        <span v-bind="props" class="d-inline-block">
          <NuxtLink to="/subscription" class="subscription-badge">
            <VChip :color="badgeColor" variant="tonal" style="height: 30px;">
              <VIcon icon="tabler-credit-card" size="16" start />
              <template v-if="subscription.status === 'pending_payment'">
                Ожидает оплаты
              </template>
              <template v-else-if="subscription.status === 'trialing'">
                {{ planName || 'Пробный' }}
                <span v-if="showUsageCounter" class="ms-1 opacity-90">{{ usedDays.used }}/{{ usedDays.total }}</span>
              </template>
              <template v-else>
                {{ planName || 'Бесплатно' }}
                <span v-if="showUsageCounter" class="ms-1 opacity-90">{{ usedDays.used }}/{{ usedDays.total }}</span>
              </template>
            </VChip>
          </NuxtLink>
        </span>
      </template>
    </VTooltip>
  </span>
</template>

<style scoped>
.subscription-badge {
  text-decoration: none;
}
.subscription-badge:hover :deep(.v-chip) {
  opacity: 0.9;
}
</style>
